
function clearFormDismissalStates() {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) { // key can be null if an item was removed during iteration
      if (key.endsWith('-dismissed-in-session') || key.endsWith('-dismissed-after-submit')) {
        keysToRemove.push(key);
      }
    }
  }

  for (const key of keysToRemove) {
    // console.log('Clearing localStorage key:', key); // For debugging
    localStorage.removeItem(key);
  }
}

clearFormDismissalStates();

function checkFormSubmitSuccess(formEmbedElement) {
  if (!formEmbedElement || !formEmbedElement.shadowRoot) {
    return;
  }
  // console.log("Checking form submit success");
  if (formEmbedElement.shadowRoot.querySelector('[data-testid="banner-success"]')) {
    // console.log("Success banner detected inside shopify-forms-embed. Reloading page.");
    formEmbedElement.shadowRoot.querySelector("#app-embed").addEventListener("click", function() {
      clearFormDismissalStates();
      window.location.reload();
    });
    formEmbedElement.shadowRoot.querySelector("[data-testid=btn-close]").addEventListener("click", function() {
      clearFormDismissalStates();
      window.location.reload();
    });
  }
}

function hideTeaserButton(formEmbedElement) {
  if (!formEmbedElement || !formEmbedElement.shadowRoot) {
    return;
  }

  const teaserElement = formEmbedElement.shadowRoot.querySelector("[class*=_teaserContainer_]");
  if (teaserElement) {
    teaserElement.style.cssText = `
      display: none;
      --container-border-radius: 0;
    `;
  }
}

function handleFormEmbed(formEmbedElement, replaceTextTimeout=1000) {
  if (formEmbedElement) {
    checkFormSubmitSuccess(formEmbedElement);

    const shadowRoot = formEmbedElement.shadowRoot;
    if (shadowRoot) {
      const formElement = shadowRoot.querySelector('[class*=_formFieldset_]');

      if (formElement) {

        const formFileInputFields = formElement.querySelectorAll('input');
        const formFieldButtons = formElement.querySelectorAll('button');
        const formDivs = shadowRoot.querySelectorAll('[class*=_gridItem_][class*=_imageLoaded_]');
        const formGeneral = shadowRoot.querySelector('[class*=_formContainer_]');
        //const formButtonFields = formElement.querySelectorAll('button._formSubmitButton_1ll8d_81');
        //const formpFields = formElement.querySelectorAll('._formFileInputField_ehvsf_5 p');


        formFileInputFields.forEach(inputField => {
          inputField.style.cssText = `
              border-radius:0px !important;
            `;
        });

        formFieldButtons.forEach(button => {
          button.style.cssText = `
              border-radius:0px !important;
            `;
        });

        formGeneral.style.cssText = `
              border-radius:0px !important;
            `;


        formDivs.forEach(container => {
          container.style.cssText = `${container.style.cssText}; border-radius: 0px !important;`;
        });

        setTimeout(() => {
          const emailLabel = shadowRoot.getElementById("label-email");
          if (emailLabel) {
            emailLabel.innerHTML = "Enter your Email";
          }

          const phoneLabel = shadowRoot.getElementById("label-phone_number");
          if (phoneLabel) {
            phoneLabel.innerHTML = "Enter your Phone Number";
          }
          

          const yearLabel = shadowRoot.getElementById("label-YYYY");
          if (yearLabel) {
            yearLabel.innerHTML = "Year";
          }

          const monthLabel = shadowRoot.getElementById("label-MM");
          if (monthLabel) {
            monthLabel.innerHTML = "Month";
          }

          const dayLabel = shadowRoot.getElementById("label-DD");
          if (dayLabel) {
            dayLabel.innerHTML = "Day";
          }

          const termElement = shadowRoot.querySelector("[class*=_formFieldset_] [class*=_radioField_] [class*=_textBody_]");
          if (termElement) {
            termElement.innerHTML = termElement.innerHTML.replace("I have read and agree to the terms and conditions", 'I have read and agree to the <a href="/pages/terms-and-conditions">terms and conditions</a>');
          }
        }, replaceTextTimeout);

        // Style
        var style = document.createElement('style');
        style.innerHTML = `
          * {
            box-sizing: border-box !important;
            font-family: ACaslonPro, HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
            --container-border-radius: 0;
            --form-field-border-radius: 0;
            --button-border-radius: 0;
            --forms-overlay-background-color: transparent;
          }

          h2 {
              font-size: 13px !important;
              letter-spacing: .13px !important;
              line-height: 15px !important;
              font-weight: 400 !important;
          }
          @media(min-width: 1150px) {
            h2 {
                font-size: 24px !important;
                font-weight: 400 !important;
                letter-spacing: .24px;
                line-height: 28px !important;
            }
          }

          @media(max-width: 767px) {
            section[class*=_formContainer_][role=dialog] {
              width: 73% !important;
            }
          }
          @media(min-width: 1150px) {
            section[class*=_formContainer_][role=dialog] {
              max-width: 70% !important;
            }
          }

          ._flagIcon_py6yc_5 {
              height: 35px !important;
              width: 37px !important;
          }


          form button[type=submit] {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px !important;
            padding: 6px 10px !important;
            font-size: 12px;
            letter-spacing: .08px;
            line-height: 7px;
          }
          @media(min-width: 1150px) {
            form button[type=submit] {
              height: 45px !important;
              padding: 6px 10px !important;
              font-size: 14px;
              letter-spacing: .14px;
              line-height: 16px;
            }
          }

          [class*=_formHeader_] [class*=_textBody_] {
              font-size: 12px !important;
              letter-spacing: .12px;
              line-height: 14px;
          }
          @media(min-width: 1150px) {
            [class*=_formHeader_] [class*=_textBody_] {
              font-size: 16px !important;
              letter-spacing: 0.16px !important;
              line-height: 18px !important;
            }
          }

          [class*=_birthdayText_] {
              text-align: center;
              font-size: 12px !important;
              letter-spacing: 0.08px !important;
              line-height: 7px !important;
          }
          @media(min-width: 1150px) {
            [class*=_birthdayText_] {
              font-size: 14px !important;
              letter-spacing: 0.14px !important;
              line-height: 16px !important;
            }
          }

          [class*=_verticalLayout_] > label:nth-child(2) {
            display: none;
          }

          fieldset legend {
            display: none;
          }

          @media(min-width: 1150px) {
            [class*=_grid_] {
              grid-template-columns: 38% minmax(0, 1fr) !important;
            }
          }

          @media (min-width: 1150px) {
            [class*=_gridItemContent_] {
              padding: 30px 25px 15px !important;
            }
          }

          form {
            gap: 8px !important;
          }
          @media(min-width: 1150px) {
            form {
              gap: 15px !important;
            }
          }

          form input:not([type=radio]) {
            height: 30px !important;
            padding: 6px 10px !important;
            text-align: center;
          }
          form input[type=tel] {
            text-align: start;
          } 
          @media(min-width: 1150px) {
            form input:not([type=radio]) {
              height: 45px !important;
              padding: 6px 10px !important;
            }
          }

          form label, form input:not([type=radio]) {
            font-size: 12px !important;
            letter-spacing: 0.2px !important;
            line-height: 18px !important;
            width: 100%;
            text-align: center;
          }
          form label {
            font-style: italic !important;
          }
          @media (min-width: 1150px) {
            form label, form input:not([type=radio]) {
              font-size: 14px !important;
              letter-spacing: 0.14px !important;
              line-height: 16px !important;
            }
          }

          form fieldset[name="custom#confirm_your_agreement"] {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            order: 5;
          }

          form fieldset[name="custom#confirm_your_agreement"] [class*=_error_] {
            font-style: italic;
            letter-spacing: .05px;
            line-height: 7px;
          }

          [class*=_formFieldset_] [class*=_textBody_] {
              --forms-body-font: italic 400 12px ACaslonPro, HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
              letter-spacing: .05px;
              line-height: 7px;
              text-align: start;
          }
          @media(min-width: 1150px) {
            [class*=_formFieldset_] [class*=_textBody_] {
              --forms-body-font: italic 400 14px ACaslonPro, HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
            }
          }

          .phone-country-selector > div {
                height: 100%;
          }

          @media(min-width: 1230px) and (max-width: 1366px) {
              section[role=dialog] {
                  overflow-y: hidden !important;
                  
              }
              section[role=dialog] [data-sizing="form-wrapper"] {
                  max-height: 82vh !important;
              }
              section[role=dialog] [data-sizing="form-wrapper"]
              form input,
              form button[type=submit] {
                  height: 50px !important;
              }
          }

          button[aria-controls=country-selector-dropdown] {
            min-height: 100%;
            max-height: 100%;
            justify-content: center;
            align-items: center;
            padding: 0;
          }

          button[aria-controls=country-selector-dropdown] span {
              align-self: center;
              text-align: center;
              justify-content: center;
          }

          [class*=_formFieldset_] [class*=_radioField_] input {
            border-radius: unset !important;
          }

          [class*=_formFieldContainer_]:focus-within [class*=_formInputFieldLabel_], [class*=_formFieldContainer_] [class*=_inputFilled_] {
                transform: translateY(calc(2em * -0.5)) scale(0.70) !important;
                font-size: 10px !important;
          }
          @media(max-width: 767px) {
            [class*=_formInputFieldLabel] {
              top: 6px !important;
            }
          }

          #label-phone_number {
            text-align: left;
            font-size: 12px !important;
          }
          @media(max-width: 1149px) {
            #label-phone_number {
              transform: translateY(calc(2em * -0.3)) scale(0.80) !important;
            }    
          }
          @media(min-width: 1150px) {
            #label-phone_number {
              font-size: 14px !important;
            }
          }
          @media(max-width: 1149px) {
            #phone_number {
              height: 100% !important;
            }
          }
        `;
        formEmbedElement.shadowRoot.appendChild(style);

        /*


        formpFields.forEach(container => {
          container.style.cssText = `
            margin:0;
            padding:0;
            background: transparent;
          `;
        });

        formButtonFields.forEach(container => {
          container.style.cssText = `
            width:200px;
            font-weight:800;
            margin:15px auto;
          `;
        });


        formElement.style.cssText = `
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          flex-direction: row;
          padding: 0 2px;
        `;
          */


      }

    }
  }
}

let doesHideFormEmbedModalFooter = false;
const FORM_EMBED_SELECTOR = "#app-embed-container-609431";
const FORM_EMBED_SELECTOR_FOOTER = "#app-embed-container-725597";

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      const formEmbedElement = document.querySelector(FORM_EMBED_SELECTOR);
      const formEmbedElementFooter = document.querySelector(FORM_EMBED_SELECTOR_FOOTER);

      // Hide form embed modal for footer when first access to store
      if (!doesHideFormEmbedModalFooter) {
        if (formEmbedElementFooter && formEmbedElementFooter.shadowRoot) {
          const closeButton = formEmbedElementFooter.shadowRoot.querySelector('[class*="formCloseButton"]');
          const formContainer = formEmbedElementFooter.shadowRoot.querySelector('#form-container-ref');
          if (closeButton && formContainer) {
            closeButton.click();

            const appEmbedElement = formEmbedElementFooter.shadowRoot.querySelector(".appEmbed");
            appEmbedElement.style.setProperty('display', 'none', 'important');
            
            doesHideFormEmbedModalFooter = true;
          }
        }
      }

      handleFormEmbed(formEmbedElement);
      handleFormEmbed(formEmbedElementFooter, replaceTextTimeout=0);
      hideTeaserButton(formEmbedElementFooter);

      // Support show poup subscription for signup button in footer
      if (!formEmbedElementFooter) {
        return;
      }
      const shadowRoot = formEmbedElementFooter.shadowRoot;
      if (!shadowRoot) {
        return;
      }
      const triggerButton = document.querySelector('.mox-custom-trigger');
      if (triggerButton) {
        triggerButton.addEventListener('click', function(event) {
          event.preventDefault(); // Prevenir comportamiento por defecto (por ejemplo, abrir un modal)


          // Buscar dentro de #app-embed un botón con clase que contenga "teaserContainer"
          const teaserButton = shadowRoot.querySelector('[class*="teaserContainer"]');
          if (teaserButton) {
            // Prevent hide form embed modal 
            doesHideFormEmbedModalFooter = true;
            const appEmbedElement = shadowRoot.querySelector(".appEmbed");
            appEmbedElement.style.setProperty('display', 'flex', 'important');
            teaserButton.click(); // Simular el click
          } else {
          }

        });
      }

    }
  });
});


observer.observe(document.body, { childList: true, subtree: true });



